import DownloadIcon from "@mui/icons-material/GetApp";
import { CircularProgress, IconButton } from "@mui/material";
import Chip from "@mui/material/Chip";
import useNotify from "./useNotify";
import React from "react";

const DownloadField = ({ ...props }) => {
  const { docId, docType, docFileName, appId, showIcon } = props;
  const [loading, setLoading] = React.useState(false);
  const [progress, setProgress] = React.useState<number | null>(null);
  // console.log("test ran DownloadField props ===>", props);
  const reqUrl =
    `${import.meta.env.VITE_API_URL}/files/download2/` +
    appId +
    "?docId=" +
    docId +
    "&docType=" +
    docType;
  // let reqUrl = `${import.meta.env.VITE_API_URL}/files/download2/` + appId;

  const { error, info } = useNotify();
  const handDownload = async (docFileName: string, reqUrl: string) => {
    setLoading(true);
    setProgress(null);
    try {
      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");
      const response = await fetch(`${reqUrl}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "X-CSRF-TOKEN": csrfToken ?? "",
          "X-XSRF-TOKEN": csrfToken ?? "",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        if (response?.message) {
          error(response.message);
        } else {
          error("Network response was not ok, File not found");
        }
        return;
      }

      const contentType = response.headers.get("content-type") || "";
      if (
        contentType.includes("application/json") ||
        contentType.includes("text/html")
      ) {
        const textData = await response.text();
        try {
          const jsonData = JSON.parse(textData);
          error(jsonData?.message || "File not found");
        } catch {
          error("File not found");
        }
        return;
      }

      const contentLength = Number(response.headers.get("content-length") || 0);
      const reader = response.body?.getReader();
      if (!reader) {
        error("Download stream is unavailable");
        return;
      }

      const chunks: ArrayBuffer[] = [];
      let receivedLength = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }
        if (value) {
          const normalizedChunk = new Uint8Array(value.byteLength);
          normalizedChunk.set(value);
          chunks.push(normalizedChunk.buffer);
          receivedLength += normalizedChunk.length;
          if (contentLength > 0) {
            setProgress(
              Math.min(100, Math.round((receivedLength / contentLength) * 100))
            );
          }
        }
      }

      const blobbody = new Blob(chunks, {
        type: contentType || "application/octet-stream",
      });
      if (blobbody.size === 0) {
        error("File not found");
        return;
      }

      // Create a blob URL for the file content
      const url = window.URL.createObjectURL(blobbody);

      // Create a temporary link element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", appId + "_" + docFileName);

      // Append the link to the document body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      // info(
      //   "File download has started. Saving may take a moment in your browser."
      // );
    } catch (_err) {
      error("Error downloading attachment");
    } finally {
      setLoading(false);
      setProgress(null);
    }
  };

  if (showIcon === "false") {
    return (
      <>
        <Chip
          label={
            loading
              ? `${docFileName}${
                  typeof progress === "number"
                    ? ` (${progress}%)`
                    : " (Downloading...)"
                }`
              : docFileName
          }
          onClick={() => handDownload(docFileName, reqUrl)}
          disabled={loading}
          sx={{ mb: 1, color: "#1976d2" }}
        />
        <br />
      </>
    );
  }
  return (
    <IconButton
      onClick={() => handDownload(docFileName, reqUrl)}
      disabled={loading}
    >
      {loading ? (
        <CircularProgress
          size={24}
          variant={
            typeof progress === "number" ? "determinate" : "indeterminate"
          }
          value={typeof progress === "number" ? progress : undefined}
        />
      ) : (
        <DownloadIcon sx={{ color: "#1976d2" }} />
      )}
    </IconButton>
  );
};
export default DownloadField;
